import { createFileRoute, redirect } from "@tanstack/react-router";

/** Usage/MRR vive en Panel → Estado de plataforma (paridad Booking Hub). */
export const Route = createFileRoute("/admin/ops/usage")({
  beforeLoad: () => {
    throw redirect({ to: "/admin", search: { tab: "usage-ops" } as never });
  },
});
